module.exports = __webpack_public_path__ + "static/media/addAcnt-bg.af3cc546.jpg";